import { Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { WhatsAppButton } from "@/components/WhatsAppButton";

const requirements = [
  "Warganegara Malaysia, berumur 21 tahun ke atas",
  "Pendapatan bulanan minimum RM2,500",
  "Makan gaji, berkerja sendiri atau pemilik perniagaan",
  "Dokumen asas: MyKad, slip gaji atau penyata bank",
];

export const SyaratAsas = () => (
  <section
    data-testid="syarat-section"
    className="bg-[#F8F9FA] py-20 sm:py-28"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <Reveal>
          <p className="text-sm text-gold-dark uppercase tracking-widest font-semibold">
            Syarat Asas
          </p>
          <h2 className="mt-3 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-navy">
            Layak Memohon? Semak Di Sini.
          </h2>
          <p className="mt-4 text-base sm:text-lg text-slate-600 leading-relaxed">
            Jika anda memenuhi kriteria asas berikut, anda berkemungkinan
            layak untuk pilihan pembiayaan yang kami tawarkan.
          </p>
        </Reveal>

        <Reveal delay={0.12}>
          <ul
            data-testid="syarat-list"
            className="mt-8 space-y-4"
          >
            {requirements.map((req, i) => (
              <li
                key={req}
                className="flex items-start gap-4 rounded-2xl border border-navy/5 bg-white p-5 shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)]"
              >
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gold/15">
                  <Check className="w-5 h-5 text-gold-dark" />
                </span>
                <span className="text-sm sm:text-base text-slate-700 font-medium pt-1">
                  {req}
                </span>
              </li>
            ))}
          </ul>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-10">
            <WhatsAppButton
              location="syarat"
              testId="syarat-whatsapp-button"
              size="md"
            >
              Semak Kelayakan Saya
            </WhatsAppButton>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
